import { render, staticRenderFns } from "./pwkitDownload.vue?vue&type=template&id=6ebd792d&scoped=true&"
import script from "./pwkitDownload.vue?vue&type=script&lang=js&"
export * from "./pwkitDownload.vue?vue&type=script&lang=js&"
import style0 from "./pwkitDownload.vue?vue&type=style&index=0&id=6ebd792d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebd792d",
  null
  
)

component.options.__file = "pwkitDownload.vue"
export default component.exports